import { render, staticRenderFns } from "./PingCell.vue?vue&type=template&id=4889fb6c&scoped=true&"
import script from "./PingCell.vue?vue&type=script&lang=js&"
export * from "./PingCell.vue?vue&type=script&lang=js&"
import style0 from "./PingCell.vue?vue&type=style&index=0&id=4889fb6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4889fb6c",
  null
  
)

export default component.exports